export default "__VITE_ASSET__CSqP6pqj__"